import React from "react";
import FeaturedCitiesContainer from "./Sub-Components/FeaturedCitiesContainer";

const FeaturedCities = () => {
    return (
        <FeaturedCitiesContainer />
    )
}

export default FeaturedCities;